import { ProductsResponse } from 'src/modules/products/shared/types';

export const MOCK_RES = {
    GET_products: {
        insurances: {
            standardLiabilities: [
                {
                    id: {
                        organizationId: 'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                        productId: '11111111-1111-1111-1111-111111111111',
                    },
                    name: 'Liability (debited Liability Deposit applies)',
                    code: 'BSTD',
                    description:
                        '<p>Upon vehicle collection a liability deposit, excluding any credit card administration fees, is required and will be debited to the customer’s credit card.&nbsp;For further details see Terms above.</p>',
                    popupInformation:
                        '<p>This is the popup information for BSTD products</p>', //comes from products
                    price: {
                        unitOfMeasure: 'Night',
                        currency: 'AUD',
                        amount: 100.0,
                        rateValue: 33.333333333333333333333333333, // eslint-disable-line
                        originalRateValue: 40.333333333333333333333333333, // eslint-disable-line
                    },
                    prepaid: true,
                    uniqueProductId: '11111111-1111-1111-1111-111111111111-u', //rentalProductId
                    order: 0,
                    quantity: 0,
                    requiresQuantity: true,
                },
            ],
            reducedLiabilities: [
                {
                    id: {
                        organizationId: 'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                        productId: '22222222-2222-2222-2222-222222222222',
                    },
                    name: 'Liability Reduction Option 4WD',
                    code: 'LRO4WD',
                    description:
                        '<p>This option reduces the accident liability to AU$500 for 4WD vehicles.</p>',
                    popupInformation:
                        '<p>This is the popup information for LRO4WD products</p>',
                    price: {
                        unitOfMeasure: 'Night',
                        currency: 'AUD',
                        amount: 100.0,
                        originalAmount: 120,
                        rateValue: 33.333333333333333333333333333, // eslint-disable-line
                        originalRateValue: 40.333333333333333333333333333, // eslint-disable-line
                        adjustments: [
                            {
                                code: 'LRO4WDiscount',
                                name: 'LRO4WD Discount',
                                description:
                                    '<p>This is a discount for LRO4WD product</p>',
                                type: 'Discount',
                                discount: {
                                    value: 50.0,
                                    unit: 'Percentage',
                                },
                                amountDueAtSupplier: 0.0,
                            },
                        ],
                    },
                    uniqueProductId: '22222222-2222-2222-2222-222222222222-u',
                    order: 3,
                    quantity: 0,
                    requiresQuantity: false,
                },
                {
                    id: {
                        organizationId: 'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                        productId: '33333333-3333-3333-3333-333333333333',
                    },
                    name: 'Inclusive Pack 4WD',
                    code: 'INCPACK4',
                    description:
                        '<p>Inclusions are:</p><ul><li>Liability Reduction Option (liability reduced to $500)</li><li>Single vehicle rollover cover</li><li>Extra Driver Fees</li><li>Linen exchange after 7 hire days (on request)</li><li>Camping table</li><li>Camping chairs (chairs per person travelling)</li><li>Child / Booster seat - on request (cannot be fitted to some vehicle categories)</li><li>Portable fan heater (on request)</li></ul>',
                    popupInformation:
                        '<p>This is the popup information for INCPACK4 products</p>',
                    price: {
                        unitOfMeasure: 'Night',
                        currency: 'AUD',
                        amount: 120.0,
                        rateValue: 33.333333333333333333333333333, // eslint-disable-line
                    },
                    uniqueProductId: '33333333-3333-3333-3333-333333333333-u',
                    order: 2,
                    quantity: 0,
                    requiresQuantity: false,
                },
            ],
            //This only returned if the customter has selected LRO4WD or INCPACK4
            optionalLiabilityUpgrades: [
                {
                    id: {
                        organizationId: 'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                        productId: '44444444-4444-4444-4444-444444444444',
                    },
                    name: '4WD Max Cover',
                    code: '4WDMAX',
                    description:
                        '<p>Inclusions are:</p><ul><li>Reduces liability to nil</li><li>Unlimited kms</li><li>Overhead and underbody damage cover</li><li>Towing and vehicle recovery costs from 4WD roads</li></ul><p><strong>NB - Can only be purchased in conjunction with the Liability Reduction Option or the Inclusive Pack</strong></p>',
                    popupInformation:
                        '<p>This is the popup information for 4WDMAX products</p>',
                    price: {
                        unitOfMeasure: 'Night',
                        currency: 'AUD',
                        amount: 100.0,
                        rateValue: 33.333333333333333333333333333, // eslint-disable-line
                    },
                    uniqueProductId: '44444444-4444-4444-4444-444444444444-u',
                    order: 1,
                    quantity: 1,
                    readOnly: true,
                    requiresQuantity: false,
                },
            ],
        },
        extras: {
            recommended: {
                code: 'recommended',
                name: 'Recommended',
                order: 1,
                products: [
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: 'ff039dbb-e05a-4411-be14-06b5ef688b5a',
                        },
                        name: '500 kilometre package',
                        code: '500KMSDAYG',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 240.0,
                            rateValue: 240.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: 'a913ba9b-949d-481f-8b12-95c6fc1743c4',
                        order: 6,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                    {
                        minQuantity: 1,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '70047e6a-8d02-45e3-9124-16ac1f09e04f',
                        },
                        name: 'Cleaning Pack',
                        code: 'CLEANPACK',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 85.0,
                            rateValue: 85.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '3c7f4ef9-1ab0-4ab5-acec-3e35a9519c0a',
                        order: 2,
                        quantity: 1,
                        prepaid: false,
                        included: false,
                    },
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '867a0a1f-cf15-492c-97bf-79b03b4022c7',
                        },
                        name: 'Extended Roadside Assistance',
                        code: 'ERA',
                        price: {
                            unitOfMeasure: 'Day',
                            amount: 60.0,
                            rateValue: 5.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '0c4caecc-f536-45a7-b0bf-6851ae5913f2',
                        order: 4,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: 'f98c5a8a-92b3-4172-af57-c870b624b026',
                        },
                        name: 'Refuelling Pack',
                        code: 'REFUELPACK',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 199.0,
                            rateValue: 199.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '0f9ba722-5f8b-464c-a8f5-036b811aee58',
                        order: 1,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '7dbf0f16-620d-4123-bcbd-5bb45350fe81',
                        },
                        name: 'Windscreen and Tyre Protection Plus Extended Roadside Assistance',
                        code: 'WTPAERA',
                        price: {
                            unitOfMeasure: 'Day',
                            amount: 180.0,
                            rateValue: 15.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: 'feb1ea4d-e541-4fef-822e-17d1e19624e7',
                        order: 5,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                ],
            },
            campingAndLivingEquipment: {
                code: 'campingAndLivingEquipment',
                name: 'Camping and Living Equipment',
                order: 3,
                products: [
                    {
                        minQuantity: 2,
                        maxQuantity: 1000,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '823fdb47-3ced-43f6-aeb7-156d51ac023a',
                        },
                        name: 'Camping Chair(s)',
                        code: 'CAMPCHAIR',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 40.0,
                            rateValue: 40.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '95b1ef54-e888-4b23-9206-57aad5522c54',
                        order: 1,
                        quantity: 2,
                        prepaid: false,
                        included: false,
                    },
                    {
                        minQuantity: 0,
                        maxQuantity: 1000,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '1d5a4044-df69-455e-92d6-6e90bb29b1b0',
                        },
                        name: 'Camping Table(s)',
                        code: 'CAMPTABLE',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 29.0,
                            rateValue: 29.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '4384c79a-6698-496d-ab35-ac8f0ac76c9e',
                        order: 2,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '2397a750-c762-466f-a917-7bf82c68543c',
                        },
                        name: 'Prepaid Gas Bottle Refill',
                        code: 'PGO',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 25.0,
                            rateValue: 25.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '15c294c6-e4de-4a1c-9450-559c59464a89',
                        order: 4,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                ],
            },
            'on-RoadEssentials': {
                code: 'onRoadEssentials',
                name: 'On-Road Essentials',
                order: 2,
                products: [
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: '2a95abce-2b7b-4e65-bdde-39d3d8c6a109',
                        },
                        name: 'Fan / Heater.',
                        code: 'HEATER',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 0.0,
                            originalAmount: 18.0,
                            originalRateValue: 18.0,
                            rateValue: 0.0,
                            currency: 'AUD',
                            adjustments: [
                                {
                                    code: 'heidi100%',
                                    discount: {
                                        value: 100.0,
                                        unit: 'Percentage',
                                    },
                                },
                            ],
                        },
                        uniqueProductId: 'caa50304-1d84-4fd5-ae44-178e69c8421e',
                        order: 4,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                ],
            },
            otherExtras: {
                code: 'otherExtras',
                name: 'Other Extras',
                order: 4,
                products: [
                    {
                        minQuantity: 0,
                        maxQuantity: 1,
                        id: {
                            organizationId:
                                'ff27eac8-a949-4d79-aa2d-87d9a4886eb5',
                            productId: 'ec4c2645-c556-4c8c-8295-58f76fd7d9fc',
                        },
                        name: 'Pet Fee',
                        code: 'PETFEES',
                        price: {
                            unitOfMeasure: 'Fixed',
                            amount: 299.0,
                            rateValue: 299.0,
                            currency: 'AUD',
                        },
                        uniqueProductId: '6769a755-cabf-4e71-8c74-ced628369760',
                        order: 1,
                        quantity: 0,
                        prepaid: false,
                        included: false,
                    },
                ],
            },
        },
    } as ProductsResponse,
};
